"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcceleratingDistributor__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_rewardToken",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "tokenCumulativeStaked",
                type: "uint256",
            },
        ],
        name: "Exit",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "RecoverToken",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardsToSend",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "tokenLastUpdateTime",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "tokenRewardPerTokenStored",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "userRewardsOutstanding",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "userRewardsPaidPerToken",
                type: "uint256",
            },
        ],
        name: "RewardsWithdrawn",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "averageDepositTime",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "cumulativeBalance",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "tokenCumulativeStaked",
                type: "uint256",
            },
        ],
        name: "Stake",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "enabled",
                type: "bool",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "baseEmissionRate",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "maxMultiplier",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "secondsToMaxMultiplier",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "lastUpdateTime",
                type: "uint256",
            },
        ],
        name: "TokenConfiguredForStaking",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "remainingCumulativeBalance",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "tokenCumulativeStaked",
                type: "uint256",
            },
        ],
        name: "Unstake",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "stakedToken",
                type: "address",
            },
        ],
        name: "baseRewardPerToken",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "stakedToken",
                type: "address",
            },
            {
                internalType: "bool",
                name: "enabled",
                type: "bool",
            },
            {
                internalType: "uint256",
                name: "baseEmissionRate",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "maxMultiplier",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "secondsToMaxMultiplier",
                type: "uint256",
            },
        ],
        name: "configureStakingToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "stakedToken",
                type: "address",
            },
        ],
        name: "exit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "stakedToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "getAverageDepositTimePostDeposit",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "stakedToken",
                type: "address",
            },
        ],
        name: "getCumulativeStaked",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getCurrentTime",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "stakedToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getOutstandingRewards",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "stakedToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getTimeSinceAverageDeposit",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "stakedToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getUserRewardMultiplier",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "stakedToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getUserStake",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "cumulativeBalance",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "averageDepositTime",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "rewardsAccumulatedPerToken",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "rewardsOutstanding",
                        type: "uint256",
                    },
                ],
                internalType: "struct AcceleratingDistributor.UserDeposit",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "data",
                type: "bytes[]",
            },
        ],
        name: "multicall",
        outputs: [
            {
                internalType: "bytes[]",
                name: "results",
                type: "bytes[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
        ],
        name: "recoverToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "rewardToken",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "stakedToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "stake",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "stakedToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "beneficiary",
                type: "address",
            },
        ],
        name: "stakeFor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "stakingTokens",
        outputs: [
            {
                internalType: "bool",
                name: "enabled",
                type: "bool",
            },
            {
                internalType: "uint256",
                name: "baseEmissionRate",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "maxMultiplier",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "secondsToMaxMultiplier",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "cumulativeStaked",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "rewardPerTokenStored",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "lastUpdateTime",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "stakedToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "unstake",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "stakedToken",
                type: "address",
            },
        ],
        name: "withdrawReward",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "0x60a06040523480156200001157600080fd5b50604051620025f9380380620025f98339810160408190526200003491620000a8565b6001600055620000443362000056565b6001600160a01b0316608052620000da565b600180546001600160a01b038381166001600160a01b0319831681179093556040519116919082907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a35050565b600060208284031215620000bb57600080fd5b81516001600160a01b0381168114620000d357600080fd5b9392505050565b6080516124f562000104600039600081816103ff01528181611028015261131b01526124f56000f3fe608060405234801561001057600080fd5b50600436106101775760003560e01c80638da5cb5b116100d8578063b42652e91161008c578063d8f8083f11610066578063d8f8083f146103d4578063f2fde38b146103e7578063f7c618c1146103fa57600080fd5b8063b42652e91461039b578063b86e321c146103ae578063c2a672e0146103c157600080fd5b80639be65a60116100bd5780639be65a6014610355578063ac9650d814610368578063adc9772e1461038857600080fd5b80638da5cb5b146103035780639b8f04b71461034257600080fd5b806342129a501161012f5780636616af07116101145780636616af07146102ad578063715018a6146102e65780637229d982146102f057600080fd5b806342129a501461021457806348a94dc91461029a57600080fd5b806329cb924d1161016057806329cb924d146101b55780632bfb323f146101bb5780633710d4c7146101ce57600080fd5b80630700f7a11461017c5780630f86107c146101a2575b600080fd5b61018f61018a366004611fda565b610421565b6040519081526020015b60405180910390f35b61018f6101b036600461200d565b610470565b4261018f565b61018f6101c9366004611fda565b61052a565b6101e16101dc366004611fda565b6105d6565b60405161019991908151815260208083015190820152604080830151908201526060918201519181019190915260800190565b610263610222366004612049565b6002602081905260009182526040909120805460018201549282015460038301546004840154600585015460069095015460ff909416959492939192909187565b6040805197151588526020880196909652948601939093526060850191909152608084015260a083015260c082015260e001610199565b61018f6102a8366004612049565b61066d565b61018f6102bb366004612049565b73ffffffffffffffffffffffffffffffffffffffff1660009081526002602052604090206004015490565b6102ee6106f5565b005b61018f6102fe366004611fda565b610709565b60015473ffffffffffffffffffffffffffffffffffffffff165b60405173ffffffffffffffffffffffffffffffffffffffff9091168152602001610199565b6102ee610350366004612064565b610841565b6102ee610363366004612049565b61095e565b61037b6103763660046120a0565b610b5c565b6040516101999190612183565b6102ee610396366004612203565b610c51565b6102ee6103a9366004612049565b610d68565b6102ee6103bc366004612049565b610eb6565b6102ee6103cf366004612203565b6110eb565b6102ee6103e236600461223b565b611311565b6102ee6103f5366004612049565b61168a565b61031d7f000000000000000000000000000000000000000000000000000000000000000081565b73ffffffffffffffffffffffffffffffffffffffff82811660009081526002602090815260408083209385168352600790930190529081206001015461046790426122b9565b90505b92915050565b73ffffffffffffffffffffffffffffffffffffffff80841660009081526002602090815260408083209386168352600790930190529081208282036104ba57600101549050610523565b6000670de0b6b3a76400006104cf8787610421565b83546104dc9087906122cc565b6104ee87670de0b6b3a76400006122df565b6104f891906122f6565b61050291906122df565b61050c91906122f6565b905080826001015461051e91906122cc565b925050505b9392505050565b73ffffffffffffffffffffffffffffffffffffffff80831660009081526002602090815260408083209385168352600790930190529081208161056d8585610709565b905060006ec097ce7bc90715b34b9f10000000008284600201546105908961066d565b61059a91906122b9565b85546105a691906122df565b6105b091906122df565b6105ba91906122f6565b90508260030154816105cc91906122cc565b9695505050505050565b6106016040518060800160405280600081526020016000815260200160008152602001600081525090565b5073ffffffffffffffffffffffffffffffffffffffff918216600090815260026020818152604080842094909516835260079093018352908390208351608081018552815481526001820154938101939093529081015492820192909252600390910154606082015290565b73ffffffffffffffffffffffffffffffffffffffff81166000908152600260205260408120600481015482036106a7576005015492915050565b6004810154600182015460068301546106c090426122b9565b6106ca91906122df565b6106dc90670de0b6b3a76400006122df565b6106e691906122f6565b816005015461052391906122cc565b6106fd611741565b61070760006117c2565b565b73ffffffffffffffffffffffffffffffffffffffff80831660009081526002602090815260408083209385168352600790930190529081206001810154158061075157508054155b1561076757670de0b6b3a764000091505061046a565b73ffffffffffffffffffffffffffffffffffffffff841660009081526002602052604081206003015461079a8686610421565b6107ac90670de0b6b3a76400006122df565b6107b691906122f6565b9050670de0b6b3a76400008111156107d35750670de0b6b3a76400005b73ffffffffffffffffffffffffffffffffffffffff851660009081526002602081905260409091200154670de0b6b3a7640000906108129082906122b9565b61081c90836122df565b61082691906122f6565b61083890670de0b6b3a76400006122cc565b95945050505050565b6002600054036108b2576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152601f60248201527f5265656e7472616e637947756172643a207265656e7472616e742063616c6c0060448201526064015b60405180910390fd5b6002600081815573ffffffffffffffffffffffffffffffffffffffff851681526020919091526040902054839060ff16610948576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152601760248201527f7374616b6564546f6b656e206e6f7420656e61626c656400000000000000000060448201526064016108a9565b610953848484611839565b505060016000555050565b610966611741565b6040517f70a0823100000000000000000000000000000000000000000000000000000000815230600482015260009073ffffffffffffffffffffffffffffffffffffffff8316906370a0823190602401602060405180830381865afa1580156109d3573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906109f79190612331565b73ffffffffffffffffffffffffffffffffffffffff831660009081526002602052604090206006015490915015610a5e5773ffffffffffffffffffffffffffffffffffffffff8216600090815260026020526040902060040154610a5b90826122b9565b90505b60008111610ac8576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152601660248201527f43616e2774207265636f766572203020746f6b656e730000000000000000000060448201526064016108a9565b610b08610aea60015473ffffffffffffffffffffffffffffffffffffffff1690565b73ffffffffffffffffffffffffffffffffffffffff8416908361198a565b8173ffffffffffffffffffffffffffffffffffffffff167ffba2d3bdfb2d601eb66a89783a2c614856101cadce71556753c2edadd60c831c82604051610b5091815260200190565b60405180910390a25050565b60608167ffffffffffffffff811115610b7757610b7761234a565b604051908082528060200260200182016040528015610baa57816020015b6060815260200190600190039081610b955790505b50905060005b82811015610c4a57610c1a30858584818110610bce57610bce612379565b9050602002810190610be091906123a8565b8080601f016020809104026020016040519081016040528093929190818152602001838380828437600092019190915250611a6392505050565b828281518110610c2c57610c2c612379565b60200260200101819052508080610c4290612414565b915050610bb0565b5092915050565b600260005403610cbd576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152601f60248201527f5265656e7472616e637947756172643a207265656e7472616e742063616c6c0060448201526064016108a9565b6002600081815573ffffffffffffffffffffffffffffffffffffffff841681526020919091526040902054829060ff16610d53576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152601760248201527f7374616b6564546f6b656e206e6f7420656e61626c656400000000000000000060448201526064016108a9565b610d5e838333611839565b5050600160005550565b73ffffffffffffffffffffffffffffffffffffffff8116600090815260026020526040812060060154829103610dfa576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152601b60248201527f7374616b6564546f6b656e206e6f7420696e697469616c697a6564000000000060448201526064016108a9565b610e048233611a88565b73ffffffffffffffffffffffffffffffffffffffff82166000908152600260209081526040808320338452600701909152902054610e439083906110eb565b610e4c82610eb6565b73ffffffffffffffffffffffffffffffffffffffff8216600081815260026020526040908190206004015490513392917fbc2a67d422c268da6fe45f3e7d194e1d98906d221f1cfad62a5c80f2cd209f4c91610eaa91815260200190565b60405180910390a35050565b600260005403610f22576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152601f60248201527f5265656e7472616e637947756172643a207265656e7472616e742063616c6c0060448201526064016108a9565b6002600081815573ffffffffffffffffffffffffffffffffffffffff831681526020919091526040812060060154829103610fb9576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152601b60248201527f7374616b6564546f6b656e206e6f7420696e697469616c697a6564000000000060448201526064016108a9565b610fc38233611a88565b73ffffffffffffffffffffffffffffffffffffffff8216600090815260026020908152604080832033845260070190915290206003810154801561104f576000600383015542600183015561104f73ffffffffffffffffffffffffffffffffffffffff7f000000000000000000000000000000000000000000000000000000000000000016338361198a565b73ffffffffffffffffffffffffffffffffffffffff8416600081815260026020818152604092839020600681015460059091015460038801549388015485518881529384019290925293820193909352606081019190915260808101919091523391907f72d2511ac7dd6d1171d9b798c2662417660eb70235ed1b47dfe9a015929cdf409060a0015b60405180910390a3505060016000555050565b600260005403611157576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152601f60248201527f5265656e7472616e637947756172643a207265656e7472616e742063616c6c0060448201526064016108a9565b6002600081815573ffffffffffffffffffffffffffffffffffffffff8416815260209190915260408120600601548391036111ee576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152601b60248201527f7374616b6564546f6b656e206e6f7420696e697469616c697a6564000000000060448201526064016108a9565b6111f88333611a88565b73ffffffffffffffffffffffffffffffffffffffff83166000908152600260209081526040808320338452600701909152812080549091849183919061123f9084906122b9565b909155505073ffffffffffffffffffffffffffffffffffffffff84166000908152600260205260408120600401805485929061127c9084906122b9565b909155506112a3905073ffffffffffffffffffffffffffffffffffffffff8516338561198a565b805473ffffffffffffffffffffffffffffffffffffffff8516600081815260026020908152604091829020600401548251888152918201949094529081019290925233917ffe7007b2e89d80edda76299251df08366480cac22e5e260f5e662e850b1f7a32906060016110d8565b611319611741565b7f000000000000000000000000000000000000000000000000000000000000000073ffffffffffffffffffffffffffffffffffffffff168573ffffffffffffffffffffffffffffffffffffffff16036113ce576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152601c60248201527f5374616b656420746f6b656e2069732072657761726420746f6b656e0000000060448201526064016108a9565b6ec097ce7bc90715b34b9f1000000000821061146c576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152602660248201527f6d61784d756c7469706c6965722063616e206e6f742062652073657420746f6f60448201527f206c61726765000000000000000000000000000000000000000000000000000060648201526084016108a9565b600081116114fc576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152602d60248201527f7365636f6e6473546f4d61784d756c7469706c696572206d757374206265206760448201527f726561746572207468616e20300000000000000000000000000000000000000060648201526084016108a9565b6b033b2e3c9fd0803ce80000008310611597576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152602960248201527f62617365456d697373696f6e526174652063616e206e6f74206265207365742060448201527f746f6f206c61726765000000000000000000000000000000000000000000000060648201526084016108a9565b73ffffffffffffffffffffffffffffffffffffffff851660009081526002602052604090206006810154156115d1576115d1866000611a88565b80547fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff001685151517815560018101849055600281018390556003810182905542600682018190556040805187151581526020810187905290810185905260608101849052608081019190915273ffffffffffffffffffffffffffffffffffffffff8716907fdf80da729e79c8aa520a27834205fd35a54135f495b79561e19bd67166250a079060a00160405180910390a2505050505050565b611692611741565b73ffffffffffffffffffffffffffffffffffffffff8116611735576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152602660248201527f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160448201527f646472657373000000000000000000000000000000000000000000000000000060648201526084016108a9565b61173e816117c2565b50565b60015473ffffffffffffffffffffffffffffffffffffffff163314610707576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e657260448201526064016108a9565b6001805473ffffffffffffffffffffffffffffffffffffffff8381167fffffffffffffffffffffffff0000000000000000000000000000000000000000831681179093556040519116919082907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a35050565b6118438382611a88565b73ffffffffffffffffffffffffffffffffffffffff808416600090815260026020908152604080832093851683526007909301905290812090611887858486610470565b9050808260010181905550838260000160008282546118a691906122cc565b909155505073ffffffffffffffffffffffffffffffffffffffff8516600090815260026020526040812060040180548692906118e39084906122cc565b9091555061190b905073ffffffffffffffffffffffffffffffffffffffff8616333087611b23565b815473ffffffffffffffffffffffffffffffffffffffff8681166000818152600260209081526040918290206004015482518a8152918201879052918101949094526060840152908516917f249b692ff3a1553daecb2b56a807466cab98a0acdca470f0d18c1064e89b57329060800160405180910390a35050505050565b60405173ffffffffffffffffffffffffffffffffffffffff8316602482015260448101829052611a5e9084907fa9059cbb00000000000000000000000000000000000000000000000000000000906064015b604080517fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe08184030181529190526020810180517bffffffffffffffffffffffffffffffffffffffffffffffffffffffff167fffffffff0000000000000000000000000000000000000000000000000000000090931692909217909152611b87565b505050565b6060610467838360405180606001604052806027815260200161249960279139611c93565b73ffffffffffffffffffffffffffffffffffffffff82166000908152600260205260409020611ab68361066d565b600582015542600682015573ffffffffffffffffffffffffffffffffffffffff821615611a5e5773ffffffffffffffffffffffffffffffffffffffff821660009081526007820160205260409020611b0e848461052a565b60038201556005820154600290910155505050565b60405173ffffffffffffffffffffffffffffffffffffffff80851660248301528316604482015260648101829052611b819085907f23b872dd00000000000000000000000000000000000000000000000000000000906084016119dc565b50505050565b6000611be9826040518060400160405280602081526020017f5361666545524332303a206c6f772d6c6576656c2063616c6c206661696c65648152508573ffffffffffffffffffffffffffffffffffffffff16611db19092919063ffffffff16565b805190915015611a5e5780806020019051810190611c07919061244c565b611a5e576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152602a60248201527f5361666545524332303a204552433230206f7065726174696f6e20646964206e60448201527f6f7420737563636565640000000000000000000000000000000000000000000060648201526084016108a9565b606073ffffffffffffffffffffffffffffffffffffffff84163b611d39576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152602660248201527f416464726573733a2064656c65676174652063616c6c20746f206e6f6e2d636f60448201527f6e7472616374000000000000000000000000000000000000000000000000000060648201526084016108a9565b6000808573ffffffffffffffffffffffffffffffffffffffff1685604051611d619190612469565b600060405180830381855af49150503d8060008114611d9c576040519150601f19603f3d011682016040523d82523d6000602084013e611da1565b606091505b509150915061051e828286611dc8565b6060611dc08484600085611e1b565b949350505050565b60608315611dd7575081610523565b825115611de75782518084602001fd5b816040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016108a99190612485565b606082471015611ead576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152602660248201527f416464726573733a20696e73756666696369656e742062616c616e636520666f60448201527f722063616c6c000000000000000000000000000000000000000000000000000060648201526084016108a9565b73ffffffffffffffffffffffffffffffffffffffff85163b611f2b576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152601d60248201527f416464726573733a2063616c6c20746f206e6f6e2d636f6e747261637400000060448201526064016108a9565b6000808673ffffffffffffffffffffffffffffffffffffffff168587604051611f549190612469565b60006040518083038185875af1925050503d8060008114611f91576040519150601f19603f3d011682016040523d82523d6000602084013e611f96565b606091505b5091509150611fa6828286611dc8565b979650505050505050565b803573ffffffffffffffffffffffffffffffffffffffff81168114611fd557600080fd5b919050565b60008060408385031215611fed57600080fd5b611ff683611fb1565b915061200460208401611fb1565b90509250929050565b60008060006060848603121561202257600080fd5b61202b84611fb1565b925061203960208501611fb1565b9150604084013590509250925092565b60006020828403121561205b57600080fd5b61046782611fb1565b60008060006060848603121561207957600080fd5b61208284611fb1565b92506020840135915061209760408501611fb1565b90509250925092565b600080602083850312156120b357600080fd5b823567ffffffffffffffff808211156120cb57600080fd5b818501915085601f8301126120df57600080fd5b8135818111156120ee57600080fd5b8660208260051b850101111561210357600080fd5b60209290920196919550909350505050565b60005b83811015612130578181015183820152602001612118565b50506000910152565b60008151808452612151816020860160208601612115565b601f017fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe0169290920160200192915050565b6000602080830181845280855180835260408601915060408160051b870101925083870160005b828110156121f6577fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffc08886030184526121e4858351612139565b945092850192908501906001016121aa565b5092979650505050505050565b6000806040838503121561221657600080fd5b61221f83611fb1565b946020939093013593505050565b801515811461173e57600080fd5b600080600080600060a0868803121561225357600080fd5b61225c86611fb1565b9450602086013561226c8161222d565b94979496505050506040830135926060810135926080909101359150565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052601160045260246000fd5b8181038181111561046a5761046a61228a565b8082018082111561046a5761046a61228a565b808202811582820484141761046a5761046a61228a565b60008261232c577f4e487b7100000000000000000000000000000000000000000000000000000000600052601260045260246000fd5b500490565b60006020828403121561234357600080fd5b5051919050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052604160045260246000fd5b7f4e487b7100000000000000000000000000000000000000000000000000000000600052603260045260246000fd5b60008083357fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe18436030181126123dd57600080fd5b83018035915067ffffffffffffffff8211156123f857600080fd5b60200191503681900382131561240d57600080fd5b9250929050565b60007fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff82036124455761244561228a565b5060010190565b60006020828403121561245e57600080fd5b81516105238161222d565b6000825161247b818460208701612115565b9190910192915050565b602081526000610467602083018461213956fe416464726573733a206c6f772d6c6576656c2064656c65676174652063616c6c206661696c6564a264697066735822122058279542ff02b69f397882804650d6aba2916365bc7a2e34a5b6c3ee54ecfa2964736f6c63430008110033";
class AcceleratingDistributor__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(_rewardToken, overrides) {
        return super.deploy(_rewardToken, overrides || {});
    }
    getDeployTransaction(_rewardToken, overrides) {
        return super.getDeployTransaction(_rewardToken, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.AcceleratingDistributor__factory = AcceleratingDistributor__factory;
AcceleratingDistributor__factory.bytecode = _bytecode;
AcceleratingDistributor__factory.abi = _abi;
